import api from '../api'

/**
 * Auth store module
 */
const auth = {
	namespaced: true,

	state: {
		/// Session object
		session: localStorage.getItem('session') ? JSON.parse(localStorage.getItem('session')) : null,

		/// Is session active flag
		bWorking: false,
	},

	getters: {
		/**
		 * Returns the session json object
		 */
		session(state, getters) {

			return state.session
		},

		/**
		 * Returns session user
		 */
		user(state, getters) {

			return (getters.session || {}).user || null
		}
	},

	mutations: {
		/**
		 * Login has been requested
		 */
		beforeLogin(state) {

			state.bWorking = true
		},

		/**
		 * Login done 
		 *
		 * @param {object} session user and JWT token
		 */
		afterLogin(state, session) {

			state.bWorking = false
			state.session = session

			// Set local storage record
			localStorage.setItem('session', JSON.stringify(session))
		},

		/**
		 * Logout, unset active flag 
		 */
		logout(state) {

			state.bWorking = false
			state.session = null

			// Unset local storage record
			localStorage.removeItem('session')
		}
	},

	actions: {
		/**
		 * Attempt login on server
		 * 
		 * @param {*} credentials login and password
		 * @return {Promise}
		 */
		async login({commit}, credentials) {
			
			// Request login
			commit('beforeLogin')

			try
			{
				const session = await api.auth(this).login(credentials.login, credentials.password)
				localStorage.setItem('session', JSON.stringify(session))

				// Commit login
				commit('afterLogin', session)

				return session
			}
			catch (err)
			{
				throw err
			}
		},

		/**
		 * Register new user and login
		 * 
		 * @param {object} data user data
		 * @return {Promise}
		 */
		async register({commit}, data) {
			
			try
			{
				const session = await api.auth(this).register(data)
				localStorage.setItem('session', JSON.stringify(session))

				// Commit login
				commit('afterLogin', session)
			}
			catch (err)
			{
				throw err
			}
		},
	
		/**
		 * Check login status
		 */
		check({commit}) {

			// Send a check message to verify that
			// we are actually authenticated
			return api.auth(this).check()
		},

		/**
		 * Logout
		 */
		logout({commit}) {

			// Terminate session here
			commit('logout')
		},

		/**
		 * Logout everywhere
		 */
		async logoutEverywhere({commit}) {

			// TODO: send logout request
		}
	}
}

export default auth